import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { cn } from '../lib/utils';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

export function OfflineBanner() {
  const { isOnline, attemptReconnect } = useAuth();
  const { theme } = useTheme();
  
  if (isOnline) return null;
  
  return (
    <div className={cn(
      "fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 px-4 py-2 rounded-full shadow-lg",
      theme === 'dark' 
        ? "bg-zinc-800 text-zinc-300 border border-zinc-700" 
        : "bg-white text-gray-700 border border-gray-200"
    )}>
      <WifiOff size={16} className="text-amber-500" />
      <span className="text-sm font-medium">Mode hors ligne</span>
      <button
        onClick={attemptReconnect}
        className={cn(
          "p-1.5 rounded-full transition-colors",
          theme === 'dark' ? "hover:bg-zinc-700" : "hover:bg-gray-100"
        )}
        title="Tenter de se reconnecter"
      >
        <RefreshCw size={14} />
      </button>
    </div>
  );
}
